<template>
  <div class="adult">
    <HeaderTop :activeIndex="activeIndex"></HeaderTop>
    <div class="adult-bannerbox">
      <img src="../../assets/home_icon23_2.png" class="bannerbox-banner">
    </div>
    <div class="adult-courseware">
      <div class="courseware-title">
        <h1>丰富的课件内容,提升通过率</h1>
        <p>多样的学习体验,保障学习效果</p>
      </div>
      <div class="pageContent">
        <div class="courseIontent">
          <div class="courseItem" v-for="course in courses" :key="course.id" v-b-modal.LoginForm>
            <img :src="course.logo" />
            <div class="itemContent">
              <div class="itemTitle">{{ course.name }} <span v-if=" course.type">{{ course.type }}</span></div>
              <div class="itemText">
                <span class="count">{{ `共${course.hour}课时` }}</span>
                <span class="price" v-if="course.amount == 0">免费</span>
                <span class="price" v-else>{{ `￥${course.amount}` }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <login-form ref="LoginForm"></login-form>
  </div>
</template>

<script>
import LoginForm from "@/components/LoginForm.vue";
import Footer from "./Footer.vue";
import HeaderTop from "./HeaderTop.vue";


export default {
  name: 'Adult',
  components: {
    LoginForm,
    HeaderTop,
    Footer
  },
  data () {
    return {
      router: true,
      activeIndex: 'newyear-adult',
      courses: []
    };
  },
  mounted () {
    this.getNotice()
  },
  methods: {
    // 列表数据
    async getNotice () {
      await this.axios.get('/portal/gaokao').then((res) => {
        this.courses = res.data
      })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep(#adult-style) {
  .nav-mid {
    .el-menu-item.is-active {
      border-bottom: none;
      color: #930B00;
      background: transparent;
    }
    .adult {
      display: flex;
      padding: 0;
      width: 276px;
      border: none;
      font-size: 26px;
      font-weight: bold;
      margin-left: 60px;
      :nth-child(1) {
        width: 60px;
        background: linear-gradient(-45deg, #fff 50%, transparent 50%);
      }
      :nth-child(2) {
        background-color: #fff;
      }
      :nth-child(3) {
        width: 60px;
        background: linear-gradient(135deg, #fff 50%, transparent 50%);
      }
    }
  }
}
.adult {
  background-color: #f5f5f5;
  .adult-bannerbox {
    width: 100%;
    position: relative;
    overflow: hidden;
    height: 500px;
    .bannerbox-banner {
      display: block;
      width: 1920px;
      position: absolute;
      left: 50%;
      margin-left: -960px;
      height: 500px;
    }
  }
  .adult-courseware {
    .courseware-title {
      margin: 100px 0;
      text-align: center;
      h1 {
        margin: 0 0 50px 0;
      }
      p {
        font-weight: bold;
      }
    }
    .pageContent {
      .courseIontent {
        padding: 0 200px;
        .courseItem {
          width: calc(33.33% - 30px);
          margin: 10px 15px;
          display: inline-block;
          box-shadow: 0px 0px 20px rgba(193, 193, 193, 0.25);
          img {
            width: 100%;
            height: 220px;
          }
          .itemContent {
            padding: 10px;
            .itemTitle {
              font-size: 20px;
              color: #333;
              span {
                font-size: 14px;
                color: #0079fe;
                background: #e1edfb;
                padding: 0px 10px;
                border-radius: 20px;
                margin-left: 5px;
                display: inline-block;
              }
            }
            .itemText {
              font-size: 14px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 5px 0;
              .count {
                color: #666;
                font-weight: 400;
              }
              .price {
                color: #ff3030;
                font-size: 20px;
                font-weight: bold;
              }
              .label {
                color: #999;
              }
              .value {
                color: #333;
              }
            }
          }
        }
      }
    }
  }
}
</style>